import { render, staticRenderFns } from "./UseCase.vue?vue&type=template&id=35246344&scoped=true&"
import script from "./UseCase.vue?vue&type=script&lang=js&"
export * from "./UseCase.vue?vue&type=script&lang=js&"
import style0 from "./UseCase.vue?vue&type=style&index=0&id=35246344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35246344",
  null
  
)

export default component.exports